import React from "react";
import MrlForm from "../Components/MrlForm";
export default class NewReviewPage extends React.Component {
	render() {
		return (
			<main className="mrl-main container">

				<div className='container text-center mb-5'>
					<div className="row align-items-center" >
						<div className="col-md-6 mb-5">
							<img
								src="https://mattiamerlini.it/image/mattia-merlini-in-piedi-1.png"
								alt="Mattia Merlini"
								loading="lazy"
								className='img-fluid'
							/>
						</div>
						<div className="col-md-6 mb-5">
							<h1>Lasciami una recensione</h1>
							<p className='mb-5'>
								In questo corso ci siamo conosciuti, ci siamo confrontati e abbiamo imparato molte cose nuove.
							</p>
							<p className='mb-5'>
								<strong>Hai voglia di lasciarmi una recensione?</strong>
							</p>
							<p className='mb-5'>
								Questo mi permette di avere le "carte in regola" per:
							</p>
							<p>✅ <u>Dare una mano ad altre persone</u></p>
							<p>✅ <u>Organizzare corsi sempre più completi, semplici ed utili</u></p>
							<p>✅ <u>Dare il mio contributo nella diffusione della tecnologia</u></p>
						</div>
					</div>
				</div>

				<div className='container text-center mb-5'>
					<div className='mb-5'>
						<h2>Aiutami a fare sempre meglio</h2>
						<p>Compila i campi qua sotto e poi premi: "Ok ho fatto!"</p>
					</div>
					<MrlForm />
				</div>
			</main>
		);
	}
}